export const confirmationTraductor = (language: string, key: string) => {
    const text: any = {
        en: {
            title: 'Request Summary',
            download: 'Download summary',
            review: 'Scroll down to confirm and continue with your request. Please review all the information carefully.',
            coverageInformation: 'Coverage Information',
            edit: 'Edit',
            insuredValue: 'Insured Value',
            emailSubject: 'Contract Signature',
            emailBody: 'Dear customer, please sign the attached contract.',
            summaryUnavailableTitle: 'We could not load your summary',
            summaryUnavailableMessage: 'We could not find your application answers. Try again in a few seconds, or go back to the form to pick up where you left off.',
            retry: 'Try again',
            yes: 'Yes',
            no: 'No'
        },
        es: {
            title: 'Resumen de la Solicitud',
            download: 'Descarga el resumen',
            review: 'Desplázate hasta abajo para confirmar y continuar con tu solicitud. No olvides revisar toda la información completada cuidadosamente.',
            coverageInformation: 'Información de cobertura',
            edit: 'Editar',
            insuredValue: 'Valor asegurado',
            emailSubject: 'Firma de contrato',
            emailbody: 'Estimado cliente, por favor firme el contrato adjunto.',
            summaryUnavailableTitle: 'No pudimos cargar tu resumen',
            summaryUnavailableMessage: 'No encontramos las respuestas de tu solicitud. Vuelve a intentarlo en unos segundos o regresa al formulario para retomar desde donde estabas.',
            retry: 'Reintentar',
            yes: 'Si',
            no: 'No'
        },
        pt: {
            title: 'Resumo da sua Proposta de Seguro de Vida',
            download: 'Baixe o resumo',
            review: 'Desça até o final para confirmar e continuar com sua proposta. Não se esqueça de revisar cuidadosamente todas as informações preenchidas.',
            messageAboveLogo: 'Esta proposta formaliza o interesse do proponente em contratar o seguro e contém as informações necessárias para análise e aceitação do risco pela seguradora.',
            messageBelowLogo: 'A aceitação desta proposta está sujeita à análise técnica do risco pela Seguradora.',
            coverageInformation: 'Informações de cobertura',
            edit: 'Editar',
            insuredValue: 'Valor Asegurado',
            emailSubject: 'Assinatura do contrato',
            emailBody: 'Prezado cliente, por favor assine o contrato anexado.',
            summaryUnavailableTitle: 'Não foi possível carregar seu resumo',
            summaryUnavailableMessage: 'Não encontramos as respostas da sua proposta. Tente novamente em alguns segundos ou volte ao formulário para retomar de onde parou.',
            retry: 'Tentar novamente',
            yes: 'Sim',
            no: 'Não'
        }
    }
    return text[language][key];
}